import React from "react";

/**
 * Global error boundary — catches unhandled React errors and triggers
 * the ErrorBrain toast instead of showing a white screen or stack trace.
 *
 * Wraps the entire app. When an error is caught:
 * 1. Logs to console (for dev)
 * 2. Calls the ErrorBrain context to show a user-friendly toast
 * 3. Renders children normally (React recovers on next render cycle)
 */
export class ErrorBrainBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBrainBoundary]", error, errorInfo);

    // Fire the error toast via the callback prop
    if (this.props.onError) {
      this.props.onError("UNKNOWN_ERROR", {
        fingerprint: "",
        endpoint: window.location.pathname,
      });
    }

    // Auto-recover after a tick so the app doesn't stay blank
    setTimeout(() => this.setState({ hasError: false }), 100);
  }

  render() {
    if (this.state.hasError) {
      // Briefly show nothing while recovering — toast handles UX
      return null;
    }
    return this.props.children;
  }
}
